import { render } from "./DesktopBar.vue?vue&type=template&id=088ad670&scoped=true&ts=true"
import script from "./DesktopBar.vue?vue&type=script&lang=ts"
export * from "./DesktopBar.vue?vue&type=script&lang=ts"

import "./DesktopBar.vue?vue&type=style&index=0&id=088ad670&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088ad670"]])

export default __exports__